import { render } from "./menu.vue?vue&type=template&id=2e076008&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=2e076008&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e076008"]])

export default __exports__